/**
 * ProfessocialPost unterscheidet die Templates und stellt alle Module dafür bereit
 */

import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import {
  PostTypeEnum, PostingTemplate, ScreenEnum,
} from '@professocial/professocialTypes/types/commonTypes'
import {
  GooglePost,
  GetGooglePageRequest,
  PostContentImage,
  DeletePostRequest,
  DeferredPost, NetworkType,
} from '@3m5/sm_publish-frontend-api'

import GoogleMyBusinessOverview from './GoogleMyBusinessOverview'
import {
  confirmManualDeferredPostInitiated,
  declineManualDeferredPostInitiated,
  deleteManualDeferredPostInitiated,
  deleteGooglePostInitiated,
  getGooglePageInitiated,
  retryManualDeferredPostInitiated,
} from '../../../store/googleMyBusiness/googleMyBusiness.actions'
import DialogComponent from '@professocial/professocialFormComponents/FormComponents/DialogComponent'
import {
  ConfirmManualDeferredPostRequest,
  DeclineManualDeferredPostRequest, DeleteManualDeferredPostRequest, RetryManualDeferredPostRequest,
} from '@3m5/sm_publish-frontend-api'
import { EUserRole } from '@professocialApi/professocial-core-frontend-api'

export interface IGoogleMyBusinessPostProps {
   post: GooglePost | PostingTemplate | DeferredPost
   networkPageId: string
   networkUserId: string
   width?: number
   userRole?: EUserRole
   onEditFeed?: (post: GooglePost | PostingTemplate) => void
   onDeleteFeed?: (id: string | undefined) => void
   onRetryPost?: (id: string) => void
   onConfirmPost?: (id: string) => void
   onDeclinePost?: (id: string) => void
   onDeletePost?: (id: string) => void
   postType?: PostTypeEnum
   size?: ScreenEnum
   networkType?: NetworkType
   img?: PostContentImage
 }

const GoogleMyBusinessPostTemplate: React.FC<IGoogleMyBusinessPostProps> = (props: IGoogleMyBusinessPostProps) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const dispatchGetGoogleMyBusinessPage = useCallback((params: GetGooglePageRequest) => dispatch(getGooglePageInitiated(params)), [dispatch])
  const dispatchDeletePost = useCallback((params: DeletePostRequest) => dispatch(deleteGooglePostInitiated(params)), [dispatch])
  const dispatchConfirmManualDeferredPost = useCallback((params: ConfirmManualDeferredPostRequest) => dispatch(confirmManualDeferredPostInitiated(params)), [dispatch])
  const dispatchDeclineManualDeferredPost = useCallback((params: DeclineManualDeferredPostRequest) => dispatch(declineManualDeferredPostInitiated(params)), [dispatch])
  const dispatchDeleteManualDeferredPost = useCallback((params: DeleteManualDeferredPostRequest) => dispatch(deleteManualDeferredPostInitiated(params)), [dispatch])
  const dispatchRetryManualDeferredPost = useCallback((params: RetryManualDeferredPostRequest) => dispatch(retryManualDeferredPostInitiated(params)), [dispatch])

  const [deleteRequest, setDeleteRequest] = useState<string | null>(null)

  useEffect(() => {
    const googleMyBusinessParams: GetGooglePageRequest = {
      networkPageId: props.networkPageId,
      networkUserId: props.networkUserId,
    }
    dispatchGetGoogleMyBusinessPage(googleMyBusinessParams)
  }, [],
  )

  const onDeleteFeed = () => {
    if (deleteRequest) {
      const deletePostParams: DeletePostRequest = {
        networkPageId: props.networkPageId,
        networkType: NetworkType.GoogleMyBusiness,
        networkPostId: deleteRequest,
      }
      dispatchDeletePost(deletePostParams)
      setDeleteRequest(null)
    }
  }

  const postType = PostTypeEnum.MESSAGE

  return (
    <>
      <GoogleMyBusinessOverview
        userRole={props.userRole}
        postType={postType}
        size={props.size}
        width={props.width}
        networkPageId={props.networkPageId}
        networkUserId={props.networkUserId}
        post={props.post}
        img={props.img}
        onEditFeed={props.onEditFeed && props.onEditFeed}
        onDeleteFeed={(id) => {
          setDeleteRequest(id || null)
        }}
        onRetryPost={(id: string) => {
          const params: RetryManualDeferredPostRequest = {
            deferredPostId: id,
          }
          dispatchRetryManualDeferredPost(params)
        }}
        onConfirmPost={(id: string) => {
          const params: ConfirmManualDeferredPostRequest = {
            deferredPostId: id,
          }
          dispatchConfirmManualDeferredPost(params)
        }}
        onDeclinePost={(id: string) => {
          const params: DeclineManualDeferredPostRequest = {
            deferredPostId: id,
          }
          dispatchDeclineManualDeferredPost(params)
        }}
        onDeletePost={(id: string) => {
          const params: DeleteManualDeferredPostRequest = {
            deferredPostId: id,
          }
          dispatchDeleteManualDeferredPost(params)
        }}
        networkType={NetworkType.GoogleMyBusiness}
      />
      <DialogComponent
        type='error'
        title={t('postMessages:deleteWarningTitle')}
        message={t('postMessages:deletePostWarning')}
        open={deleteRequest !== null}
        confirmLabel={t('common:delete')}
        cancelLabel={t('common:cancel')}
        autoClose={false}
        requestActions
        onClose={() => setDeleteRequest(null)}
        onCancel={() => setDeleteRequest(null)}
        onConfirm={() => {
          onDeleteFeed()
        }}
      />
    </>
  )
}
export default GoogleMyBusinessPostTemplate
